<div class="mt-4 flex flex-col">
    @if (showAlert()) {
        <fuse-alert class="mb-4" [type]="alertType()" [dismissible]="false">
            <div class="whitespace-pre-line">{{ alertMessage() }}</div>
        </fuse-alert>
    }
    @if (importCompleted()) {
        @if (importSummary()) {
            <div class="rounded-lg border border-gray-200 bg-gray-50 p-4">
                <h3 class="mb-3 text-lg font-semibold">Zusammenfassung</h3>
                <div class="space-y-2 text-sm">
                    <div class="flex justify-between">
                        Dateiname:
                        <span class="text-gray-900">{{ importSummary().fileName }}</span>
                    </div>
                    <div class="flex justify-between">
                        Zielordner:
                        <span class="text-gray-900">{{ importSummary().directoryName }}</span>
                    </div>
                    <div class="flex justify-between">
                        Importierte Prompts:
                        <span class="font-semibold text-green-600">{{ importSummary().importedCount }}</span>
                    </div>
                    @if (importSummary().failedCount > 0) {
                        <div class="flex justify-between">
                            Fehlgeschlagen:
                            <span class="font-semibold text-red-600">{{ importSummary().failedCount }}</span>
                        </div>
                    }
                </div>
                @if (importSummary().errors && importSummary().errors.length > 0) {
                    <div class="mt-4">
                        <h4 class="mb-2 text-sm font-semibold">Fehlerdetails:</h4>
                        <div class="max-h-40 overflow-y-auto rounded bg-white p-3">
                            @for (error of importSummary().errors; track error.index) {
                                <div class="mb-2 text-xs text-red-600">
                                    <span class="font-medium">Prompt {{ error.index + 1 }}</span> ({{ error.name }}):
                                    {{ error.message }}
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        }
    } @else {
        <form class="flex flex-col gap-4" [formGroup]="importForm" (ngSubmit)="onSubmit()">
            <mat-form-field>
                <mat-label>Zielverzeichnis</mat-label>
                <mat-select formControlName="directoryUid" required>
                    @for (directory of directories(); track directory.uid) {
                        <mat-option [value]="directory.uid"> {{ directory.name }} </mat-option>
                    }
                </mat-select>
                @if (importForm.get('directoryUid')?.hasError('required')) {
                    <mat-error>Bitte wähle ein Verzeichnis aus</mat-error>
                }
            </mat-form-field>
            <div>
                <span class="mb-2 block text-sm font-medium text-gray-700">JSON-Datei auswählen (max. 5MB)</span>
                <input id="file-input" type="file" accept=".json" (change)="onFileSelected($event)" class="hidden" />
                <label
                    for="file-input"
                    class="inline-block cursor-pointer rounded-md border-0 bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-700 shadow-sm transition-colors duration-150 file:border-0 hover:bg-blue-100">
                    Datei auswählen
                </label>
                @if (selectedFile()) {
                    <div class="mt-2 flex items-center text-sm text-gray-600">
                        <mat-icon class="mr-1 text-green-600" svgIcon="mat_outline:check_circle"></mat-icon>
                        <span>{{ selectedFile().name }} ({{ (selectedFile().size / 1024).toFixed(2) }} KB)</span>
                    </div>
                }
            </div>
        </form>
        <mat-accordion class="mt-4">
            <mat-expansion-panel class="my-0 border border-gray-100">
                <mat-expansion-panel-header>
                    <mat-panel-title>Erwartetes JSON-Format anzeigen</mat-panel-title>
                </mat-expansion-panel-header>
                <mat-expansion-panel-content>
                    <div class="rounded-md border border-gray-200 bg-gray-50 p-4">
                        <pre class="overflow-x-auto rounded bg-white p-2 text-sm"><code>[
    {{'{'}}"name": "Prompt Name","text": "Prompt Text","description": "Optional","tags": ["tag1", "tag2"]{{'}'}},
    {{'{'}}"name": "Weiterer Prompt","text": "Weiterer Text"{{'}'}}
]</code></pre>
                    </div>
                </mat-expansion-panel-content>
            </mat-expansion-panel>
        </mat-accordion>
    }
</div>
